import { useState } from "react";

export default function ShareButton() {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    const url = window.location.href;
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(url);
      } else {
        const input = document.createElement("input");
        input.value = url;
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
      }
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2200);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="relative">
      <button
        type="button"
        onClick={handleShare}
        className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
      >
        <i className="ri-share-line"></i>
        分享
      </button>
      {copied && (
        <div className="absolute left-0 top-full z-20 mt-2 flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-3 py-2 text-xs font-medium text-background-50 animate-fade-up">
          <i className="ri-checkbox-circle-line text-primary-400"></i>
          链接已复制到剪贴板
        </div>
      )}
    </div>
  );
}